import React, { useState } from "react";
import { AuthenticatedUser } from "../api";
import { ensureMsalInitialized, msalInstance } from "../auth/msal.config";

interface EntraLoginButtonProps {
  onError?: (error: string) => void;
  onSuccess?: (user: AuthenticatedUser, token: string) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
  showSuccess?: boolean;
}

const EntraLoginButton: React.FC<EntraLoginButtonProps> = ({
  onError,
  onSuccess,
  label,
  className,
  disabled,
  showSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const classes = [
    "entra-login-btn",
    showSuccess ? "entra-login-btn--success" : "",
    className || "",
  ].filter(Boolean).join(" ");

  const handleEntraLogin = async () => {
    setLoading(true);
    try {
      await ensureMsalInitialized(msalInstance);

      // Force redirect flow for reliability across Azure-hosted environments.
      await msalInstance.loginRedirect({
        scopes: ["openid", "profile", "email"],
        redirectStartPage: `${window.location.origin}/callback`,
      });
      return;
    } catch (error: any) {
      console.error("Entra login error:", error);

      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to sign in with Entra. Please try again.";
      if (onError) onError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleEntraLogin}
      disabled={loading || !!disabled}
      className={classes}
    >
      {loading ? "Signing in..." : (label || "Login with Daikin SSO")}
      {!loading && showSuccess && (
        <span className="material-icons entra-login-btn__icon" aria-hidden="true">check_circle</span>
      )}
    </button>
  );
};

export default EntraLoginButton;
